import type { MutableRefObject } from "react";
import React, { useRef } from "react";
import * as Styles from "./FullscreenCarouselSlider.styles";
import FullscreenCarouselImage from "./FullscreenCarouselImage";
import type { CarouselImageType } from "../../../../../utils/types";
import { handleScroll } from "../../../../../utils/sliderUtils";
import { useUscSelector } from "../../../../../redux/store";
import { isRTL } from "../../../../../../../common-deprecated/settings/utils/commonSettingUtils";

type FullscreenCarouselType = {
    images: CarouselImageType[];
    altTag: string;
    scrollEnabled: MutableRefObject<boolean>;
    updateSharedSliderIndex: (index: number) => void;
};

const FullscreenCarouselSlider = (props: FullscreenCarouselType): JSX.Element => {
    const { images, altTag, scrollEnabled, updateSharedSliderIndex } = props;

    const commonSettings = useUscSelector((state) => state.commonSettings);

    const isRtl = isRTL(commonSettings);

    const sliderRef = useRef<HTMLDivElement>(null);

    return (
        <Styles.Slider
            scrollable={images.length > 1}
            onScroll={() => scrollEnabled.current && updateSharedSliderIndex(handleScroll(sliderRef, isRtl))}
            onMouseEnter={() => {
                scrollEnabled.current = true;
            }}
            onTouchStart={() => {
                scrollEnabled.current = true;
            }}
            onMouseLeave={() => {
                scrollEnabled.current = false;
            }}
            ref={sliderRef}
            id="scroll-container"
        >
            {images.map(({ src }, index) => (
                <FullscreenCarouselImage
                    src={src}
                    key={index} // eslint-disable-line react/no-array-index-key
                    index={index}
                    altTag={altTag}
                />
            ))}
        </Styles.Slider>
    );
};

export default FullscreenCarouselSlider;
